import axios from 'axios';
import user from  '../utils/user';

export default {
  async getLogsByPolicyId(policyId) {
    try {
      const response = await axios.get(
        `${process.env.VUE_APP_API_VIDA_URL}/integrations/star/sync/${policyId}`,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
  async execute(payload) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/integrations/star/reprocess`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
